import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './AccountJulaClubCommunicationPreferences';

const AccountJulaClubCommunicationPreferencesSuspense = dynamic(
	() => import('./AccountJulaClubCommunicationPreferences'),
	{
		loading: () => <BlockLoadingSpinner />,
	},
);

export default function DynamicAccountJulaClubCommunicationPreferences(
	props: Props,
) {
	return <AccountJulaClubCommunicationPreferencesSuspense {...props} />;
}
DynamicAccountJulaClubCommunicationPreferences.displayName =
	'DynamicAccountJulaClubCommunicationPreferences';
